
import { PublicClientApplication } from '@azure/msal-browser'
import { MsalProvider } from '@azure/msal-react'
import { StrictMode } from 'react'

import { App } from 'app/App'
import { msalConfig } from 'auth/config'


const msalInstance = new PublicClientApplication(msalConfig)

export const Root = () => (
  <StrictMode>
    {/* <!-- todo: Wrap App inside or OsProvider providers once SSO is available --> */}
    <div  id="onboarding-root">
      <MsalProvider instance={msalInstance}>
        <App />
      </MsalProvider>
    </div>
  </StrictMode>
)
